<app-marketing-category [template]="content"
                        [showCategory]="true"
                        [showBottomBar]="!!viewModel.apiResult().miniHomes.length"/>
<ng-template #content>
  <div *ngIf="viewModel.currentCategory()?.big?.nameEn as name">
    <a appFocusRemove
       [routerLink]="imageLink()"
       (click)="openProduct(viewModel.currentCategory()?.link, $event)">
      <app-image-loading *ngIf="viewModel.currentCategory()?.image?.hash as hash"
                         [clickable]="!!viewModel.currentCategory()?.link"
                         [src]="hash"
                         [alt]="name"
                         [priority]="true"
                         [targetWidth]="pageSize"
                         [targetHeight]="pageSize * (viewModel.currentCategory()?.image?.aspectRatio ?? 1)"/>
    </a>
    <div class="margin-top">
      <app-product-grid [columns]="columns"
                        [width]="220"
                        [gridWidth]="pageSize"
                        [gapSize]="43"
                        [rowGapSize]="35"
                        [metaRef]="meta"
                        [imgRatio]="viewModel.apiResult().miniHomes.length ? viewModel.apiResult().miniHomes[0].aspectRatio : 1"
                        [items]="viewModel.gridItems()"/>
      <ng-template #meta let-item="item" appNgTemplate
                   [typeToken]="typeToken">
        <app-price-meta class="full-width"
                        [marginBottom]="0"
                        [meta]="item.meta"/>
      </ng-template>
    </div>
  </div>
</ng-template>
